/**
 * 予算内訳に連結する過年度修正の表示文字列を返す。0の場合は表示しないため空文字を返す。
 * @param priorYearAdjustment - その月の過年度修正の合計（マイナスあり）
 * @returns 例：「＋過年度修正：100,000円」「−過年度修正：100,000円」
 */
export const formatPriorYearAdjustment = (
  priorYearAdjustment: number
): string => {
  if (priorYearAdjustment === 0) return "";
  const operator = priorYearAdjustment > 0 ? "＋" : "−";
  return `${operator}過年度修正：${Math.abs(
    priorYearAdjustment
  ).toLocaleString()}円`;
};
